<template>
    <div :class="notificationClasses">
        <div class="dk-notification__icon tw-inline-flex tw-mr-2">
            <slot v-if="$scopedSlots.icon" name="icon"></slot>
            <dk-icon
                v-else-if="variant === 'danger'"
                name="close-filled"
                :size="isInline ? 'xs' : 's'"
                class="tw-text-feedback-danger"
            />
            <dk-icon
                v-else-if="variant === 'success'"
                name="checkmark-filled"
                :size="isInline ? 'xs' : 's'"
                class="tw-text-feedback-success"
            />
            <dk-icon
                v-else-if="variant === 'fail'"
                name="error-filled"
                :size="isInline ? 'xs' : 's'"
                class="tw-text-feedback-fail"
            />
            <dk-icon
                v-else-if="variant === 'fail'"
                name="error-filled"
                :size="isInline ? 'xs' : 's'"
                class="tw-text-feedback-fail"
            />
            <dk-icon v-else-if="variant === 'tooltip'" name="ds-help-empty" size="xs" class="tw-w-tw-text-basic" />
        </div>
        <div
            class="dk-notification__body tw-flex tw-text-sm tw-mr-2"
            :class="{ 'tw-items-center': isInline, 'tw-flex-col': !isInline }"
        >
            <h6
                v-if="title"
                class="dk-notification__title tw-font-semibold"
                :class="{
                    'tw-mb-1': !isInline,
                    'tw-mr-2': isInline,
                    'tw-text-sm tw-leading-2xs': variant !== 'tooltip',
                    'tw-text-xs tw-leading-xs': variant === 'tooltip',
                }"
            >
                {{ title }}
            </h6>
            <p
                v-if="body"
                class="dk-notification__description"
                :class="{
                    'tw-mt-1': !isInline,
                    'tw-text-sm tw-leading-2xs': variant !== 'tooltip',
                    'tw-text-xs tw-leading-xs': variant === 'tooltip',
                }"
                v-html="body"
            ></p>
        </div>
        <button
            v-if="showDismiss && variant !== 'tooltip'"
            type="button"
            class="dk-notification__dismiss tw-inline-flex tw-ml-auto"
            @click="handleDismiss"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                class="tw-w-[20px] tw-h-[20px]"
                viewBox="0 0 20 20"
                fill="currentColor"
            >
                <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                />
            </svg>
        </button>
        <button
            v-if="showDismiss && variant === 'tooltip'"
            type="button"
            class="dk-notification__dismiss tw-inline-flex tw-ml-auto"
            @click="handleDismiss"
        >
            <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clip-path="url(#clip0_2031_3578)">
                    <path
                        d="M14.25 4.8075L13.1925 3.75L9 7.9425L4.8075 3.75L3.75 4.8075L7.9425 9L3.75 13.1925L4.8075 14.25L9 10.0575L13.1925 14.25L14.25 13.1925L10.0575 9L14.25 4.8075Z"
                        fill="#141414"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_2031_3578">
                        <rect width="18" height="18" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </button>
    </div>
</template>

<script>
import DkIcon from './DkIcon.vue';

export default {
    name: 'DkNotification',
    components: {
        DkIcon,
    },
    props: {
        title: {
            default: '',
            type: String,
        },
        body: {
            default: '',
            type: String,
        },
        isInline: {
            default: false,
            type: Boolean,
        },
        variant: {
            required: true,
            validator(value) {
                return ['danger', 'success', 'info', 'fail', 'tooltip'].includes(value);
            },
        },
        showDismiss: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            isVisible: true,
        };
    },
    computed: {
        notificationClasses() {
            return [
                'dk-notification',
                'tw-inline-flex',
                'tw-p-4',
                'tw-text-sm',
                'tw-border tw-border-solid',
                {
                    'tw-items-start tw-min-w-[272px]': !this.isInline,
                    'tw-items-center tw-min-w-[647px]': this.isInline,
                    'tw-bg-slate-50 tw-border-slate-200': this.variant === 'info' || this.variant === 'tooltip',
                    'tw-bg-feedback-danger-bg tw-border-red-200': this.variant === 'danger',
                    'tw-bg-feedback-success-bg tw-border-teal-200': this.variant === 'success',
                    'tw-bg-feedback-fail-bg tw-border-feedback-fail-border': this.variant === 'fail',
                },
                { 'tw-hidden': !this.isVisible },
            ];
        },
    },
    methods: {
        handleDismiss() {
            this.isVisible = false;
            this.$emit('dismissed');
        },
    },
};
</script>
